/* GeneratedContentHash: 79632daf823f2ca1abc4baea91ffc6d4f953c057c9b7b427e31c8d6fdad94688 */
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/

import { asMessageRenderer } from '@post-office/placement-common';
import marketing from '@post-office/team-export--marketing/placements/in-app/screen-space-flags/render';
import mercury from '@post-office/team-export--mercury/placements/in-app/screen-space-flags/render';
import playground from '@post-office/team-export--playground/placements/in-app/screen-space-flags/render';
import postOfficeTemplate from '@post-office/team-export--post-office-template/placements/in-app/screen-space-flags/render';
import testMessages from '@post-office/team-export--test-messages/placements/in-app/screen-space-flags/render';

export const renderer = { ...marketing, ...mercury, ...playground, ...postOfficeTemplate, ...testMessages };

//TODO: add validator as second arguement to asMessageRenderer when validators are ready
//import { validator } from './validate';

export const { initializeMessageRenderer, MessageRenderer } = asMessageRenderer(renderer);
